import { useInitAnalytics } from "core/analytics/analytics.hooks";
import { FC, PropsWithChildren } from "react";

import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";

export const AnalyticsProvider: FC<PropsWithChildren> = ({ children }) => {
  const { appInsightPlugin } = useInitAnalytics();
  return (
    <AppInsightsContext.Provider value={appInsightPlugin}>
      {children}
    </AppInsightsContext.Provider>
  );
};
